// eslint-disable-next-line
import React from 'react';
import get from 'lodash/get';
import { sortItems } from '../../../../utils/common';
import {
  GET_ROOM_DETAILS_FOR_EDIT_ROOM,
  GET_STAFF,
  GET_DIGITAL_STUDENTS_PAGINATED_ROSTER,
} from '../../../../apollo/queries';
import QueryComponent from '../../network/QueryComponent';
import RoomForm from './RoomForm';
import { useParams } from 'react-router-dom';
import { fetchMoreStudents } from '../../../../utils/pagination';

function Container() {
  // Get the id of the room from the url.
  const { id } = useParams();
  const input = { id };

  return (
    <div className='container'>
      <h1 className='tdtk-h1 py-4' data-automation='heading-h1'>
        Edit Room Details
      </h1>
      <QueryComponent query={{ kind: 'GetStaff', specification: GET_STAFF }}>
        {(staffData) => {
          // Get and sort the staff by last/first names.
          const staff = sortItems(get(staffData, 'viewer.site.staff', []), [
            {
              name: 'lastName',
              order: 'asc',
            },
            {
              name: 'firstName',
              order: 'asc',
            },
          ]);

          return (
            <QueryComponent
              query={{
                kind: 'GetRoomDetailsForEditRoom',
                specification: GET_ROOM_DETAILS_FOR_EDIT_ROOM,
                variables: { input },
              }}
            >
              {(roomData) => {
                const room = get(roomData, 'readRoom') || {};

                if (room && room.id) {
                  return (
                    <QueryComponent
                      query={{
                        kind: 'GetDigitalStudentsPaginatedRoster',
                        specification: GET_DIGITAL_STUDENTS_PAGINATED_ROSTER,
                      }}
                      generateFetchMoreOptions={fetchMoreStudents}
                    >
                      {(studentData) => {
                        const students = (studentData?.paginatedStudents?.students || []).filter(Boolean);
                        return <RoomForm room={room} staff={staff} students={students} />;
                      }}
                    </QueryComponent>
                  );
                } else {
                  return <p className='mb-4'>Room not found.</p>;
                }
              }}
            </QueryComponent>
          );
        }}
      </QueryComponent>
    </div>
  );
}

export default Container;
